module.exports = __webpack_public_path__ + "media/chosen-js/chosen-sprite-6768c197.png";